import React, { useMemo } from 'react'

import {
  EditQuestionCard,
  QuestionCardProps,
} from '../EditQuestionCard/EditQuestionCard'

export const MemoizedEditQuestionCard = ({
  question,
  onFocus,
  isActive,
  onBlur,
  onKeyPress,
}: QuestionCardProps) =>
  useMemo(
    () => (
      <EditQuestionCard
        question={question}
        onFocus={onFocus}
        isActive={isActive}
        onBlur={onBlur}
        onKeyPress={onKeyPress}
      />
    ),
    [isActive],
  )
